import ReactDOM from 'react-dom'
import React from "react";
import PropTypes from 'prop-types'

import Tab from './tab'
import Page from './pages'
import {SelectHostingProvider,SelectHostingInitialState,SelectHostingReducer} from './state'
import {BUILD_PAGE, GUIDE_PAGE} from "./pages";

const SELECT_HOSTING_CLASSNAME  = "of-select-hosting"

const TAB_MENU = [{
  label: 'Build Your Hosting Plan',
  step: BUILD_PAGE
},{
  label: 'Need Help Choosing?',
  step: GUIDE_PAGE
}]

export const getPID = (state) =>{
  return state && state.pid
}

export const getPromo = (state) =>{
  return state && state.promo
}


const SelectHostingConnector = (props) =>{
  const {container,pid,router,promo,presets,slide,contact} = props
  const initialState = {
    ...SelectHostingInitialState,
    pid,
    router,
    promo,
    contact,
    presets,
    slide,
  }

  return ReactDOM.createPortal(
      <SelectHostingProvider reducer={SelectHostingReducer} initialState={initialState}>
        <div className={'of-select-hosting-connector'}>
          <Tab list={TAB_MENU}/>
          <Page/>
        </div>
      </SelectHostingProvider>
  ,container)
}

SelectHostingConnector.propTypes = {
  container : PropTypes.object,
  pid: PropTypes.string,
  router: PropTypes.object,
  promo: PropTypes.string,
  presets: PropTypes.string,
  slide: PropTypes.string,
  contact: PropTypes.string
}


const RenderSelectHostingConnector = (props) => {
  const domlist = Array.from(document.querySelectorAll(`.${SELECT_HOSTING_CLASSNAME}`))
  const {router} = props
  if (domlist && domlist.length) {
    return domlist.map((el, index) => {
      const pid = el.getAttribute('data-pid')
      const promo = el.getAttribute('data-promo')
      const presets = el.getAttribute('data-presets')
      const slide = el.getAttribute('data-slide-to')
      const contact = el.getAttribute('data-contact')
      return (<SelectHostingConnector
          key={index}
          container={el}
          router = {router}
          pid={pid}
          promo={promo}
          presets={presets}
          slide={slide}
          contact={contact}
      />)
    })
  }
  return (<></>)
}

RenderSelectHostingConnector.propTypes = {
  router: PropTypes.object
}

export default RenderSelectHostingConnector